// Fichier de configuration des endpoints API
const API_ENDPOINTS = {
  AUTH: {
    LOGIN: 'api/token/',
    LOGOUT: 'api/auth/logout/',
    REFRESH: 'api/auth/token/refresh/',
    REGISTER: 'api/auth/registration/',
    USER: 'api/auth/user/',
    USER_PROFILE: 'api/auth/user/'
  },
  SUBSCRIPTION: {
    BASE: 'api/subscriptions/',
    PLANS: 'api/subscriptions/plans/',
    CANCEL: (id) => `api/subscriptions/${id}/cancel/`
  },
  FAQ: {
    BASE: 'faq/api/entries/',
    LIST: 'faq/api/entries/',
    CREATE: 'faq/api/entries/',
    UPDATE: (id) => `faq/api/entries/${id}/`,
    DELETE: (id) => `faq/api/entries/${id}/`,
    BULK_IMPORT: 'faq/api/entries/bulk_import/',
    EXPORT: 'faq/api/entries/export/',
    TEST_AGENT: 'faq/api/entries/test_agent/',
    STATS: 'faq/api/entries/stats/'
  }
};

export default API_ENDPOINTS;
